export const serializeConnectionForClipboard = (connection: Connection): string =>
  JSON.stringify(connection, null, 2)

export const isConnectionClipboardPayload = (value: unknown): value is Connection => {
  if (!value || typeof value !== 'object') return false

  const candidate = value as Partial<Connection>

  return (
    typeof candidate.name === 'string' &&
    typeof candidate.r_d_earthquake === 'number' &&
    typeof candidate.r_d_wind === 'number'
  )
}

export const parseConnectionFromClipboardText = (text: string): Connection | null => {
  if (!text.trim()) return null

  try {
    const parsed: unknown = JSON.parse(text)
    return isConnectionClipboardPayload(parsed) ? parsed : null
  } catch {
    return null
  }
}

export const preparePastedConnection = (connection: Connection): Connection => ({
  ...connection,
  guid: crypto.randomUUID(),
  name: `${connection.name} (Kopie)`,
  export_comment: connection.export_comment ?? '',
})
